<template>
	<ies-form-field :field="field">
        <v-date-picker v-model="input"
                       @click.native.stop="updateField()"
                       class="no-print"
                       landscape ></v-date-picker>
        <span class="print-only">{{ this.field.value }}</span>
	</ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
		var date = new Date(this.field.value);

        return {
            input: this.field.value ? date.toISOString().split('T')[0] : ''
        }
    },

    methods: {
        updateField: function(){
			console.log(this.input);
            this.field.value = this.input
        }
    }
}
</script>


